export default {
  1: [20890, 20889], // Sooccer - Match Result - 3
  2: [20931, 20939], //Basketball - Match Winner - 2
  3: [20719, 20627], //Tennis - Match Winner - 2
  4: [20533, 20649], //Volleyball - Match Winner - 2
  5: [20854, 20722 ], //Ice Hockey - Match Winner (incl. Overtime & Penalties) - 2
  6: [20539, 20652 ], //Table Tennis - Match Winner - 2
  7: [20678, 20813 ], //Handball - Match Result - 3
  8: [20672, 20822 ], //Badminton - Match Winner - 2
  9: [20963, 20518 ], //Baseball - Match Winner - 2
  10: [20519, 20544 ], //Futsal - Match Result - 3
  11: [20811, 20824 ], //Beach Volleyball - Match Winner - 2
  12: [59246, 59321 ], //American Football - Match Winner (incl. Overtime) - 2
  14: [58612, 58611 ], //Boxing - Match Winner - 2
  16: [19421, 19416 ], //Snooker - Match Winner - 2
}
// sportId: [preMainMarketId , liveMainMarketId]

// Sports whose main market above is 3-way (1 · X · 2): their event rows show the X price
// under the 1 X 2 header; every other sport shows 1 · 2.
export const THREE_WAY_SPORTS = [1, 7, 10]
